module.exports = __webpack_public_path__ + "static/media/yellow.fadbdecc.svg";